module.exports = __webpack_public_path__ + "media/video.6622cdf0.mp4";